import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

function LiveCalender() {
  const [dateTime, setDateTime] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Live Clock
  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h6 className="mb-1 mt-2" style={{color:"#48340A"}}>📅 Date & Time : </h6>
        <h4 style={{color:"#130a66"}}>{dateTime.toLocaleDateString()}</h4>
        <h3 style={{color:"#89620d"}}>{dateTime.toLocaleTimeString()}</h3>
      </div>

      <div style={styles.card}>
        <h4 style={{color:"#89620d"}}>📆 Calendar</h4>
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
        />
        <p style={{ marginTop: "2px" }}>
          Selected Date: {selectedDate.toDateString()}
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: "10px",
    background: "#f4e1d9",
    minHeight: "70vh",
  },
  card: {
    background: "#ffffff",
    padding: "6px",
    margin: "6px auto",
    borderRadius: "8px",
    boxShadow: "0 5px 4px rgba(0,0,0,0.1)",
    maxWidth: "320px",
     
  },
};

export default LiveCalender;
